<template>
    <information-popup modal-id="inscriptionExamplesPopup">
        <template slot="header">Inscription Examples</template>
        <slot>
            <div class="modal-body inscription-modal">
                <div class="row">
                    <div class="col-sm-3">
                        <h3 class="text-danger">INSPIRING</h3>
                        <p><strong>4x8</strong></p>
                        <p>INSPIRE YOUTH</p>
                        <p>WITH SOCCER</p>
                        <p>TRADITIONS! JJ</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>KEEP BELIEVING</p>
                        <p>& GREAT THINGS</p>
                        <p>CAN HAPPEN!</p>
                        <p>RUSSO FAMILY</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">FAMILY</h3>
                        <p><strong>4x8</strong></p>
                        <p>ON THESE BRICKS</p>
                        <p>ARE UNITED FANS</p>
                        <p>BOB & TOM LUTZ</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>SO MANY MEMORIES</p>
                        <p>OF UNITED GAMES</p>
                        <p>AS A FAMILY</p>
                        <p>JJ, BJ & MJ NIR</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">TEAM</h3>
                        <p><strong>4x8</strong></p>
                        <p>BLACK & RED</p>
                        <p>BORN & RAISED</p>
                        <p>ALEX MARCUS</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>FROM MLS CUP '96</p>
                        <p>TO AUDI FIELD</p>
                        <p>FANS FOREVER</p>
                        <p>THE SMITH FAMILY</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">REMEMBRANCE</h3>
                        <p><strong>4x8</strong></p>
                        <p>IN HONOR OF</p>
                        <p>BRIAN ARMSTRONG</p>
                        <p>1996-2009 FAN!</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>MAGGIE JAMES</p>
                        <p>4EVER OUR ANGEL</p>
                        <p>IN THE STARS</p>
                        <p>MOM & DAD JAMES</p>
                    </div>
                </div>
                <hr/>
                <div class="row">
                    <div class="col-sm-3">
                        <h3 class="text-danger">ANNIVERSARY</h3>
                        <p><strong>4x8</strong></p>
                        <p>WE MET AT A</p>
                        <p>DC UNITED MATCH</p>
                        <p>MR & MRS LYTLE</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>HAPPILY MARRIED</p>
                        <p>BLACK AND RED</p>
                        <p>FOR 10 YEARS</p>
                        <p>MARY & JON NORTH</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">FATHER'S DAY</h3>
                        <p><strong>4x8</strong></p>
                        <p>DANNY MARCHIORO</p>
                        <p>BLACK & RED FAN</p>
                        <p>NUMBER ONE DAD!</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>THANK YOU DAD</p>
                        <p>FOR ALL THE</p>
                        <p>GAMES 2GETHER</p>
                        <p>TY & BO McCABE</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">MOTHER'S DAY</h3>
                        <p><strong>4x8</strong></p>
                        <p>HAPPY MOTHER'S</p>
                        <p>DAY MOM!</p>
                        <p>JEN & DON BRADY</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>#1 DC UNITED FAN</p>
                        <p>#1 MOTHER</p>
                        <p>MY MOM</p>
                        <p>VERA BRONSON</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">GENERAL</h3>
                        <p><strong>4x8</strong></p>
                        <p>THE SMITH FAMILY</p>
                        <p>BLACK & RED FANS</p>
                        <p>SINCE 1996</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>SO MANY MEMORIES</p>
                        <p>OF UNITED GAMES</p>
                        <p>AS A FAMILY</p>
                        <p>BRAD & ROB VOSS</p>
                    </div>
                </div>
            </div>
        </slot>
    </information-popup>
</template>

<script type="text/jsx">
    import InformationPopup from '@/components/popup/information-popup.vue';
    export default {
        name: 'inscription-examples',
        components: {
            'information-popup': InformationPopup
        }
    }
</script>

<style lang="scss" scoped>
    .inscription-modal {
        h3, p {
            white-space: nowrap;
        }
    }
</style>


// WEBPACK FOOTER //
// InscriptionExamples.vue?99de3768